module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/gradient-vertical-buttons/gradient-vertical-buttons.component.scss
// module id = ./src/app/features/buttons/gradient-vertical-buttons/gradient-vertical-buttons.component.scss
// module chunks = main